<template>
  <div class="contract">
    <div class="searchPart">
      <div style="display: flex; align-items: center">
        <el-input v-model="contractNum" placeholder="积分名称"></el-input>
        <el-input v-model="contractName" placeholder="积分账号"></el-input>
        <el-button class="searchBtn" @click="search">搜索</el-button>
        <el-button type="text" class="resetBtn" @click="reset">
          <i class="iconfont icon-qingchushujuku"></i>
          <span>清除条件</span>
        </el-button>
      </div>
      <div>
        <el-button type="text" size="small">新增</el-button>
      </div>
    </div>
    <div class="contractTable">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        class="tableContent"
      >
        <el-table-column
          prop="contractNum"
          label="商品名称"
          header-align="center"
          align="center"
          show-overflow-tooltip
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="contractName"
          label="商品类型"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="contractTime"
          label="商家名称"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="contractTime"
          label="商品金额"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="contractTime"
          label="兑换积分"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="contractTime"
          label="兑换时间"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="contractTime"
          label="操作"
          header-align="center"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-button type="text" size="small">修改</el-button>
            <el-button type="text" size="small">取消</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="100"
        layout="prev, pager, next, jumper"
        :total="1"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "contract",
  data() {
    return {
      contractNum: "",
      contractName: "",
      tableData: [
        // {
        //   contractNum: "",
        //   contractPeo: "",
        //   contractName: "",
        //   contractTime: "",
        //   contractMoney: "",
        //   contractType: "",
        // },
      ],
    };
  },
  methods: {
    search() {},
    reset() {},
  },
};
</script>

<style lang="less" scoped>
.searchPart {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  /deep/ .el-input {
    width: initial;
    margin-bottom: 22px;
    margin-right: 30px;
  }

  /deep/ .el-input__inner {
    width: 242px;
    height: 35px;
    min-height: 35px;
    font-size: 12px;
    color: #999999;
    background-color: #f2f4f7;
    border: 1px solid #f2f4f7;
    border-radius: 5px;

    &:hover,
    &:focus {
      background-color: #fff;
      border: 1px solid #108ee9;
    }
  }

  /deep/ .el-input__prefix {
    top: -3px;
  }

  /deep/ .el-input__suffix {
    top: 2px;
  }

  /deep/ .el-button {
    display: block;
    line-height: 35px;
    padding: 0;
    height: 35px;
  }

  .searchBtn {
    width: 82px;
    background: #3d7fff;
    border: none;
    border-radius: 15px;
    font-size: 14px;
    color: #ffffff;
    margin-bottom: 22px;
  }

  .resetBtn {
    color: #333333;
    margin-bottom: 22px;
  }
}
.contract {
  padding: 20px;
  background: #fff;
  margin-left: 15px;
  .tableContent {
    min-height: 650px;
  }
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/logManage/integralTi.vue